module.exports = __webpack_public_path__ + "static/media/medical centre.553176f7.svg";